export function setupModalA11y(): void {
    const modalLayouts = document.querySelectorAll<HTMLElement>('.modal-layout');

    modalLayouts.forEach((modal) => {
        const headerContent = modal.querySelector('.modal-header .content-block');
        if (headerContent) {
            modal.setAttribute('title', headerContent.textContent?.trim() ?? '');
        }

        const $modal = $(modal);

        $modal.on('shown.bs.modal', function (e) {
            const tabbables = $modal.find('a, input:not([type="hidden"]), select, button, textarea');
            const focusedElement = $((e as any).relatedTarget as HTMLElement);

            $modal.on('keydown', function (keydownEvent) {
                // Escape key
                if (keydownEvent.which === 27) {
                    // @ts-ignore — Bootstrap 3 .modal() plugin, no type definition
                    $modal.modal('hide');
                    focusedElement.focus();
                }

                // Tab + Shift — trap focus to last tabbable
                if (keydownEvent.shiftKey && keydownEvent.which === 9) {
                    if (document.activeElement === modal) {
                        keydownEvent.preventDefault();
                        tabbables.last().focus();
                    }
                }
            });
        });
    });
}
